export const teakTypeNamesMap = new Map<any, string>([
	['TeakTypeWorkplace', 'teakTypes.desk'],
	['TeakEntityWorkplace', 'teakTypes.desk'],
	['TeakTypeMeetingRoom', 'teakTypes.room'],
	['TeakEntityMeetingRoom', 'teakTypes.room'],
	['TeakTypeParkingSpace', 'teakTypes.parkingSpace'],
	['TeakEntityParkingSpace', 'teakTypes.parkingSpace'],
]);
